import {   
    getGroupList,
    getAccountList,
    deleteOrgGroupData,
    getOrganizationData,
    saveOrgGroupData,
    getDeviceList,
    getPortalList,
    getNetworkZoneList,
    getSsidByGroups,
    getRadioClusterGroupList
} from './model-data';

export const WAIT_INIT_MODEL = "WAIT_INIT_MODEL";
export const GET_MODEL_ORGANIZATION_DETAIL = "GET_MODEL_ORGANIZATION_DETAIL";
export const GET_MODEL_ORGANIZATION_DETAIL_FAIL = "GET_MODEL_ORGANIZATION_DETAIL_FAIL";
export const GET_MODEL_ORGANIZATION_DETAIL_SUCCESS = "GET_MODEL_ORGANIZATION_DETAIL_SUCCESS";
export const GET_MODEL_ORGANIZATION_DATA = "GET_MODEL_ORGANIZATION_DATA";
export const GET_MODEL_GROUP_DATA = "GET_MODEL_GROUP_DATA";
export const FILTER_MODEL_ORGANIZATION = "FILTER_MODEL_ORGANIZATION";
export const FILTER_MODEL_GROUP = "FILTER_MODEL_GROUP";
export const GET_MODEL_PARAMETER_DATA = "GET_MODEL_PARAMETER_DATA";
export const GET_INHERITANCEPOSITION_DATA = "GET_INHERITANCEPOSITION_DATA";
export const SAVE_MODEL_ORG_GROUP_DETAIL_DATA = "SAVE_MODEL_ORG_GROUP_DETAIL_DATA";
export const SAVE_ORG_GROUP_DATA = "SAVE_ORG_GROUP_DATA";
export const SAVE_ORG_GROUP_DATA_SUCCESS = "SAVE_ORG_GROUP_DATA_SUCCESS";
export const SAVE_ORG_GROUP_DATA_FAIL = "SAVE_ORG_GROUP_DATA_FAIL";
export const GET_MODEL_ORGANIZATION_SELECT_DATA = "GET_MODEL_ORGANIZATION_SELECT_DATA";
export const GET_MODEL_GROUP_LIST = "GET_MODEL_GROUP_LIST";
export const GET_MODEL_GROUP_LIST_FAIL = "GET_MODEL_GROUP_LIST_FAIL";
export const GET_MODEL_GROUP_LIST_SUCCESS = "GET_MODEL_GROUP_LIST_SUCCESS";
export const GET_MODEL_GROUP_DETAIL = "GET_MODEL_GROUP_DETAIL";
export const GET_MODEL_GROUP_DETAIL_FAIL = "GET_MODEL_GROUP_DETAIL_FAIL";
export const GET_MODEL_GROUP_DETAIL_SUCCESS = "GET_MODEL_GROUP_DETAIL_SUCCESS";
export const GET_MODEL_LATANDLNG_DATA = "GET_MODEL_LATANDLNG_DATA";
export const GET_MODEL_ACCOUNT_LIST = "GET_MODEL_ACCOUNT_LIST";
export const GET_MODEL_ACCOUNT_LIST_FAIL = "GET_MODEL_ACCOUNT_LIST_FAIL";
export const GET_MODEL_ACCOUNT_LIST_SUCCESS = "GET_MODEL_ACCOUNT_LIST_SUCCESS";
export const GET_MODEL_DEVICE_LIST = "GET_MODEL_DEVICE_LIST";
export const GET_MODEL_DEVICE_LIST_FAIL = "GET_MODEL_DEVICE_LIST_FAIL";
export const GET_MODEL_DEVICE_LIST_SUCCESS = "GET_MODEL_DEVICE_LIST_SUCCESS";
export const GET_MODEL_SSID_BY_GROUP_LIST = "GET_MODEL_SSID_BY_GROUP_LIST";
export const GET_MODEL_SSID_BY_GROUP_LIST_FAIL = "GET_MODEL_SSID_BY_GROUP_LIST_FAIL";
export const GET_MODEL_SSID_BY_GROUP_LIST_SUCCESS = "GET_MODEL_SSID_BY_GROUP_LIST_SUCCESS";
export const GET_MODEL_NETWOK_ZONE_LIST = "GET_MODEL_NETWOK_ZONE_LIST";
export const GET_MODEL_NETWOK_ZONE_LIST_FAIL = "GET_MODEL_NETWOK_ZONE_LIST_FAIL";
export const GET_MODEL_NETWOK_ZONE_LIST_SUCCESS = "GET_MODEL_NETWOK_ZONE_LIST_SUCCESS";
export const GET_MODEL_PORTAL_LIST = "GET_MODEL_PORTAL_LIST";
export const GET_MODEL_PORTAL_LIST_FAIL = "GET_MODEL_PORTAL_LIST_FAIL";
export const GET_MODEL_PORTAL_LIST_SUCCESS = "GET_MODEL_PORTAL_LIST_SUCCESS";
export const DELETE_ORG_GROUP_DATA = "DELETE_ORG_GROUP_DATA";
export const DELETE_ORG_GROUP_DATA_SUCCESS = "DELETE_ORG_GROUP_DATA_SUCCESS";
export const DELETE_ORG_GROUP_DATA_FAIL = "DELETE_ORG_GROUP_DATA_FAIL";
export const GET_ORGANIZATION_DATA = "GET_ORGANIZATION_DATA";
export const GET_ORGANIZATION_DATA_FAIL = "GET_ORGANIZATION_DATA_FAIL";
export const GET_ORGANIZATION_DATA_SUCCESS = "GET_ORGANIZATION_DATA_SUCCESS";
export const LOAD_MODEL_PICKDATE = "LOAD_MODEL_PICKDATE";
export const CLOSE_MODEL_PICKDATE = "CLOSE_MODEL_PICKDATE";

export const LOAD_TIME_TABLE = "LOAD_TIME_TABLE";
export const CLOSE_TIME_TABLE = "CLOSE_TIME_TABLE";
export const GET_RADIO_CLUSTER_GROUP_LIST = "GET_RADIO_CLUSTER_GROUP_LIST";
export const GET_RADIO_CLUSTER_GROUP_LIST_SUCCESS = "GET_RADIO_CLUSTER_GROUP_LIST_SUCCESS";
export const GET_RADIO_CLUSTER_GROUP_LIST_FIAL = "GET_RADIO_CLUSTER_GROUP_LIST_FAIL";



export const modelOrganizationDataAction = (orgList) => (dispatch) => {
    dispatch({
        type: GET_MODEL_ORGANIZATION_DATA,
        params: {
            orgList: orgList
        }
    });
}

export const modelGroupDataAction = (groupList) => (dispatch) => {
    dispatch({
        type: GET_MODEL_GROUP_DATA,
        params: {
            groupList: groupList
        }
    });
}

export const getModelGroupDetail = (detailData) => (dispatch) => {
    dispatch({
        type: GET_MODEL_GROUP_DETAIL,
        params: {
            modelGroupDetail: detailData
        }
    });
}

export const getModelOrgDetail = (detailData) => (dispatch) => {
    dispatch({
        type: GET_MODEL_ORGANIZATION_DETAIL,
        params: {
            modelOrgDetail: detailData
        }
    });
}

export const filterOrgAction = (orgId, orgValue) => (dispatch) => {
    dispatch({
        type: FILTER_MODEL_ORGANIZATION,
        params: {
            orgId: orgId,
            orgValue: orgValue
        }
    });
}

export const filterGroupAction = (groupId, groupValue) => (dispatch) => {
    dispatch({
        type: FILTER_MODEL_GROUP,
        params: {
            groupId: groupId,
            groupValue: groupValue
        }
    });
}

export const modelParameterDataAction = (orgColumnsConfig, groupColumnsConfig, templateColumnsConfig) => (dispatch) => {
    dispatch({
        type: GET_MODEL_PARAMETER_DATA,
        params: {
            orgColumnsConfig: orgColumnsConfig,
            groupColumnsConfig: groupColumnsConfig,
            templateColumnsConfig: templateColumnsConfig
        }
    });
}

export const saveModelOrgGroupDetailData = (info, confirm) => (dispatch) => {
    dispatch({
        type: SAVE_MODEL_ORG_GROUP_DETAIL_DATA,
        params: {
            info: info,
            confirm: confirm
        }
    });
}

export const doSaveOrgGroupData = (saveData, modalMessage, authToken, accountInfo) => (dispatch) => {

    let doPost = new Promise((resolve, reject) => {
        saveOrgGroupData(resolve, reject, saveData, modalMessage, authToken, accountInfo)
    });

    doPost
        .then((data) => {
            if ('success' === data.status) {
                dispatch({
                    type: SAVE_ORG_GROUP_DATA_SUCCESS,
                });
            } else {
                dispatch({
                    type: SAVE_ORG_GROUP_DATA_FAIL,
                    params: {
                        errMsg: data.responseMsg
                    }
                });
            }
        }).catch((err) => {
            dispatch({
                type: SAVE_ORG_GROUP_DATA_FAIL,
                params: {
                    errMsg: err
                }
            });
        });


    dispatch({
        type: SAVE_ORG_GROUP_DATA
    });
}

export const modelOrganizationSelectData = (selectOptions) => (dispatch) => {
    dispatch({
        type: GET_MODEL_ORGANIZATION_SELECT_DATA,
        params: {
            options: selectOptions
        }
    });
}
export const loadGroupList = (token, orgId) => (dispatch) => {
    let doPost = new Promise((resolve, reject) => {
        getGroupList(resolve, reject, token, orgId);
    });

    doPost
        .then((data) => {
            if ('success' === data.responseMsg) {
                dispatch({
                    type: GET_MODEL_GROUP_LIST_SUCCESS,
                    params: {
                        groupList: data.groupList
                    }
                });
            } else {
                dispatch({
                    type: GET_MODEL_GROUP_LIST_FAIL,
                    params: {
                        errMsg: data.responseMsg
                    }
                });
            }
        }).catch((err) => {
            dispatch({
                type: GET_MODEL_GROUP_LIST_FAIL,
                params: {
                    errMsg: err
                }
            });
        });

    dispatch({
        type: GET_MODEL_GROUP_LIST
    });
}

export const dispatchPickGroup = (pickGroupListData) => (dispatch) => {
    dispatch({
        type: GET_MODEL_GROUP_LIST_SUCCESS,
        params: {
            groupList: pickGroupListData
        }
    });
}

export const loadLatAndLngList = (detailData) => (dispatch) => {
    dispatch({
        type: GET_MODEL_LATANDLNG_DATA,
        params: {
            modelLatAndLngData: detailData
        }
    });
}

export const loadAccountList = (token, orgId) => (dispatch) => {
    let doPost = new Promise((resolve, reject) => {
        getAccountList(resolve, reject, token, orgId);
    });

    doPost
        .then((data) => {
            if ('success' === data.responseMsg) {
                dispatch({
                    type: GET_MODEL_ACCOUNT_LIST_SUCCESS,
                    params: {
                        accountList: data.accountList
                    }
                });
            } else {
                dispatch({
                    type: GET_MODEL_ACCOUNT_LIST_FAIL,
                    params: {
                        errMsg: data.responseMsg
                    }
                });
            }
        }).catch((err) => {
            dispatch({
                type: GET_MODEL_ACCOUNT_LIST_FAIL,
                params: {
                    errMsg: err
                }
            });
        });

    dispatch({
        type: GET_MODEL_ACCOUNT_LIST
    });
}

export const doDeleteOrgGroupData = (id, token) => (dispatch) => {
    let doPost = new Promise((resolve, reject) => {
        deleteOrgGroupData(resolve, reject, id, token);
    });

    doPost
        .then((data) => {
            if ('success' === data.status) {
                dispatch({
                    type: DELETE_ORG_GROUP_DATA_SUCCESS,
                });
            } else {
                dispatch({
                    type: DELETE_ORG_GROUP_DATA_FAIL,
                    params: {
                        errMsg: data.errMsg
                    }
                });
            }
        }).catch((err) => {
            dispatch({
                type: DELETE_ORG_GROUP_DATA_FAIL,
                params: {
                    errMsg: err
                }
            });
        });

    dispatch({
        type: DELETE_ORG_GROUP_DATA
    });
}

export const doGetOrganizationData = (token, orgSeq) => (dispatch) => {
    let doPost = new Promise((resolve, reject) => {
        getOrganizationData(resolve, reject, token, orgSeq);
    });
    
    doPost
    .then((data) => {
        if ('Success' === data.status) {
            dispatch({
                type: GET_ORGANIZATION_DATA_SUCCESS,
                params: {
                    modelOrgDetail: data.data[0]
                }
            });
        } else {
            dispatch({
                type: GET_ORGANIZATION_DATA_FAIL,
                params: {
                    errMsg: data.responseMsg
                }
            });
        }
    }).catch((err) => {
        dispatch({
            type: GET_ORGANIZATION_DATA_FAIL,
            params: {
                errMsg: err
            }
        });
    });

    dispatch({
        type: GET_ORGANIZATION_DATA
    });
}

export const loadDeviceList = (token, orgId) => (dispatch) => {
    let doPost = new Promise((resolve, reject) => {
        getDeviceList(resolve, reject, token, orgId);
    });

    doPost
        .then((data) => {
            if ('success' === data.responseMsg) {
                dispatch({
                    type: GET_MODEL_DEVICE_LIST_SUCCESS,
                    params: {
                        deviceList: data.deviceList
                    }
                });
            } else {
                dispatch({
                    type: GET_MODEL_DEVICE_LIST_FAIL,
                    params: {
                        errMsg: data.responseMsg
                    }
                });
            }
        }).catch((err) => {
            dispatch({
                type: GET_MODEL_DEVICE_LIST_FAIL,
                params: {
                    errMsg: err
                }
            });
        });

    dispatch({
        type: GET_MODEL_DEVICE_LIST
    });
}

export const loadSsidListByGroups = (token, groups) => (dispatch) => {
    let doPost = new Promise((resolve, reject) => {
        getSsidByGroups(resolve, reject, token, groups);
    });

    doPost
        .then((data) => {
            if ('success' === data.responseMsg) {
                dispatch({
                    type: GET_MODEL_SSID_BY_GROUP_LIST_SUCCESS,
                    params: {
                        ssidList: data.ssidList
                    }
                });
            } else {
                dispatch({
                    type: GET_MODEL_SSID_BY_GROUP_LIST_FAIL,
                    params: {
                        errMsg: data.responseMsg
                    }
                });
            }
        }).catch((err) => {
        dispatch({
            type: GET_MODEL_SSID_BY_GROUP_LIST_FAIL,
            params: {
                errMsg: err
            }
        });
    });

    dispatch({
        type: GET_MODEL_SSID_BY_GROUP_LIST
    });
}

export const loadGuestPortalList = (token, site) => (dispatch) => {
    let doPost = new Promise((resolve, reject) => {
        getPortalList(resolve, reject, token, site);
    });

    doPost
        .then((data) => {
            if ('success' === data.responseMsg) {
                dispatch({
                    type: GET_MODEL_PORTAL_LIST_SUCCESS,
                    params: {
                        guestPortalList: data.guestPortalList
                    }
                });
            } else {
                dispatch({
                    type: GET_MODEL_PORTAL_LIST_FAIL,
                    params: {
                        errMsg: data.responseMsg
                    }
                });
            }
        }).catch((err) => {
            dispatch({
                type: GET_MODEL_PORTAL_LIST_FAIL,
                params: {
                    errMsg: err
                }
            });
        });

    dispatch({
        type: GET_MODEL_PORTAL_LIST
    });
}

export const loadNetworkZoneList = (token, site) => (dispatch) => {
    let doPost = new Promise((resolve, reject) => {
        getNetworkZoneList(resolve, reject, token, site);
    });

    doPost
        .then((data) => {
            if ('success' === data.responseMsg) {
                dispatch({
                    type: GET_MODEL_NETWOK_ZONE_LIST_SUCCESS,
                    params: {
                        networkZoneList: data.data
                    }
                });
            } else {
                dispatch({
                    type: GET_MODEL_NETWOK_ZONE_LIST_FAIL,
                    params: {
                        errMsg: data.responseMsg
                    }
                });
            }
        }).catch((err) => {
            dispatch({
                type: GET_MODEL_NETWOK_ZONE_LIST_FAIL,
                params: {
                    errMsg: err
                }
            });
        });

    dispatch({
        type: GET_MODEL_NETWOK_ZONE_LIST
    });
}

export const loadPickDate = (data) => (dispatch) => {
    dispatch({
        type: LOAD_MODEL_PICKDATE,
        params: {
            modelPickDate: data
        }
    });
}

export const closePickDate = () => (dispatch) => {
    dispatch({
        type: CLOSE_MODEL_PICKDATE
    });
}

export const loadTimeTable = (data) => (dispatch) => {
    dispatch({
        type: LOAD_TIME_TABLE,
        params: {
            modelTimeTable: data
        }
    });
}

export const closeTimeTable = () => (dispatch) => {
    dispatch({
        type: CLOSE_TIME_TABLE
    });
}

export const doGetRadioClusterGroupList = (token, seq) => (dispatch) => {
    let doPost = new Promise((resolve, reject) => {
        getRadioClusterGroupList(resolve, reject, token, seq);
    });
    doPost
    .then((data)=>{
        if ('success' === data.status) {
            dispatch({
                type: GET_RADIO_CLUSTER_GROUP_LIST_SUCCESS,
                params: {
                    radioClusterGroupListByOrg: data.radioClusterGroupData
                }
            });
        } else {
            dispatch({
                type: GET_RADIO_CLUSTER_GROUP_LIST_FIAL,
                params: {
                    errMsg: data.status
                }
            });
        }
    }).catch((err)=>{
        dispatch({
            type: GET_RADIO_CLUSTER_GROUP_LIST_FIAL,
            params: {
                errMsg: err
            }
        });
    })
    dispatch({
        type: GET_RADIO_CLUSTER_GROUP_LIST
    });
}
